import { getServerSideContext } from 'frontend/utils/ssr-context';

/**
 * getToken taken from util/csrf.js
 */
export function getToken(): string {
  let token: string = '';

  if (typeof document !== 'undefined') {
    document.cookie.split(';').forEach(cookie => {
      if (cookie.indexOf('csrftoken') >= 0) {
        token = cookie.split('=')[1].trim();
      }
    });
  } else {
    token = getServerSideContext().backend.server_side_rendering_data.cookies.csrftoken;
  }
  return token;
}
